module.exports = __webpack_public_path__ + "static/img/hanataka_logo.ddc35bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/hanataka_logo.png
// module id = hnhP
// module chunks = 0